// extracted by mini-css-extract-plugin
export default {"change_password":"AX","password_input":"BX","change_password_title":"CX","error_message":"EX","disable_button":"FX","update_password":"GX"};
    if(module.hot) {
      // 1714654898426
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  